/**
 * Reusable List View / Card View toggle matching Crizac production toolbar.
 *
 * Provides accessible buttons with SVG icons for List and Grid views.
 */
export function ViewToggle({ view, onChange }) {
  return (
    <div className="view-toggle-wrap" role="group" aria-label="Select View">
      <span className="view-toggle-label">Select View</span>
      <div className="view-toggle-buttons">
        <button
          type="button"
          id="viewToggleList"
          className={`view-toggle-btn ${view === 'list' ? 'active' : ''}`}
          onClick={() => onChange('list')}
          aria-label="List View"
          title="List View"
          aria-pressed={view === 'list'}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4 6h16v2H4zm0 5h16v2H4zm0 5h16v2H4z" />
          </svg>
        </button>
        <button
          type="button"
          id="viewToggleCard"
          className={`view-toggle-btn ${view === 'card' ? 'active' : ''}`}
          onClick={() => onChange('card')}
          aria-label="Card View"
          title="Card View"
          aria-pressed={view === 'card'}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
            <path d="M4 4h7v7H4zm9 0h7v7h-7zm-9 9h7v7H4zm9 0h7v7h-7z" />
          </svg>
        </button>
      </div>
    </div>
  );
}
